// moleculeRecipes.js
import '../Style/moleculeRecipes.css';

const moleculeRecipes = [
    {
      name: 'Eau',
      formula: ['H₂', 'O'],
      description: 'Composant essentiel dans presque toutes les recettes de pâtisserie.'
    },
    {
      name: 'Dioxyde de Carbone',
      formula: ['C', 'O₂'],
      description: 'Produit lors de la fermentation ou en utilisant de la levure chimique.'
    },
    {
      name: 'Chlorure de Sodium',
      formula: ['Na', 'Cl'],
      description: 'Sel de table, utilisé pour rehausser le goût des préparations.'
    },
    {
      name: 'Glucose',
      formula: ['C₆', 'H₁₂', 'O₆'],
      description: 'Un sucre simple, présent dans de nombreux aliments sucrés.'
    },
    {
      name: 'Saccharose',
      formula: ['C₁₂', 'H₂₂', 'O₁₁'],
      description: 'Sucre de table utilisé dans les recettes pour ajouter de la douceur.'
    },
    {
      name: 'Acide Acétique',
      formula: ['C₂', 'H₄', 'O₂'],
      description: 'Composant du vinaigre, parfois utilisé dans des recettes pour sa propriété acide.'
    },
    {
      name: 'Acide Lactique',
      formula: ['C₃', 'H₆', 'O₃'],
      description: 'Présent dans les produits laitiers comme le lait fermenté, utilisé parfois dans les recettes de gâteaux ou biscuits.'
    },
    {
      name: 'Ammoniac',
      formula: ['N', 'H₃'],
      description: 'Utilisé dans certaines recettes anciennes pour rendre les biscuits plus légers.'
    },
    {
      name: 'Bicarbonate de Sodium',
      formula: ['Na', 'H', 'C', 'O₃'],
      description: 'Un agent de levée courant dans les recettes de pâtisserie.'
    },
    {
      name: 'Acide Citrique',
      formula: ['C₆', 'H₈', 'O₇'],
      description: 'Trouvé dans les agrumes, utilisé dans certains types de confiseries.'
    },
    {
      name: 'Protéines (Albumines)',
      formula: ['C', 'H', 'O', 'N'], // La composition chimique exacte dépend des protéines spécifiques.
      description: 'Les protéines des œufs, qui aident à structurer et stabiliser les pâtisseries.'
    },
    {
      name: 'Maltose',
      formula: ['C₁₂', 'H₂₂', 'O₁₁'],
      description: 'Un sucre complexe trouvé dans certains sirops ou produits céréaliers.'
    },
    {
      name: 'Triglycérides',
      formula: ['C₅₅', 'H₉₈', 'O₆'], // Représentation générique des triglycérides.
      description: 'Les graisses présentes dans le beurre ou l\'huile.'
    },
    {
      name: 'Lécithine',
      formula: ['C₄₂', 'H₇₈', 'O₈', 'N', 'P'], // Représentation simplifiée.
      description: 'Un émulsifiant trouvé dans les jaunes d’œufs.'
    },
    {
      name: 'Fructose',
      formula: ['C₆', 'H₁₂', 'O₆'],
      description: 'Sucre naturellement présent dans les fruits.'
    }
  ];
  
  // Exportation de la constante pour être utilisée ailleurs
  export default moleculeRecipes;
  